import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { canEdit, getUserType } from "../permissions";
import API_BASE from "../config";

const EditProperty = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const property = location.state?.property;
    const userType = getUserType();
    const allowEdit = canEdit(userType, "properties");

    const [form, setForm] = useState({
        id: "", name: "", shortform: "", units: "", active: "1", date: ""
    });
    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState({ text: "", type: "" });

    useEffect(() => {
        if (!allowEdit) { navigate("/dashboard"); return; }
        if (!property) {
            navigate("/dashboard/properties");
            return;
        }
        setForm({
            id: property.id || "",
            name: property.name || "",
            shortform: property.shortform || "",
            units: property.units || "0",
            active: property.active !== undefined ? property.active : "1",
            date: property.date ? property.date.substring(0, 10) : ""
        });
    }, [property, navigate, allowEdit]);

    if (!allowEdit) return null;

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSaving(true);
        setMsg({ text: "", type: "" });

        const formData = new URLSearchParams();
        Object.keys(form).forEach((key) => {
            if (key !== "id") formData.append(key, form[key]);
        });

        fetch(`${API_BASE}/api/updatedatas`, {
            method: "POST",
            headers: { Authorization: "1", Table: "projects", Id: form.id },
            body: formData,
        })
            .then((res) => res.json())
            .then((json) => {
                setSaving(false);
                if (json.status === true) {
                    setMsg({ text: "Project updated successfully!", type: "success" });
                    setTimeout(() => navigate("/dashboard/properties"), 1500);
                } else {
                    setMsg({ text: json.message || "Failed to update project.", type: "error" });
                }
            })
            .catch((err) => {
                setSaving(false);
                setMsg({ text: "An error occurred.", type: "error" });
            });
    };

    return (
        <div style={{ maxWidth: "600px", margin: "0 auto", padding: "24px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                <button
                    onClick={() => navigate("/dashboard/properties")}
                    style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer" }}
                >
                    ←
                </button>
                <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#0f172a", margin: 0 }}>Edit Property</h2>
            </div>

            {msg.text && (
                <div style={{
                    padding: "12px", borderRadius: "8px", marginBottom: "20px",
                    background: msg.type === "success" ? "#ecfdf5" : "#fef2f2",
                    color: msg.type === "success" ? "#059669" : "#dc2626",
                    border: `1px solid ${msg.type === "success" ? "#a7f3d0" : "#fecaca"}`
                }}>
                    {msg.text}
                </div>
            )}

            <form
                onSubmit={handleSubmit}
                style={{ background: "#fff", padding: "24px", borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}
            >
                <div style={{ display: "grid", gap: "16px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Project Name</label>
                        <input
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            required
                            placeholder="e.g. Skyline Towers"
                            style={{ padding: "10px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px" }}
                        />
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Shortform</label>
                            <input
                                name="shortform"
                                value={form.shortform}
                                onChange={handleChange}
                                placeholder="e.g. SFB"
                                style={{ padding: "10px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px" }}
                            />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Total Units</label>
                            <input
                                name="units"
                                type="number"
                                value={form.units}
                                onChange={handleChange}
                                placeholder="e.g. 150"
                                style={{ padding: "10px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px" }}
                            />
                        </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Date</label>
                            <input
                                type="date"
                                name="date"
                                value={form.date}
                                onChange={handleChange}
                                style={{ padding: "10px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px" }}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", textTransform: "uppercase" }}>Status</label>
                            <select
                                name="active"
                                value={form.active}
                                onChange={handleChange}
                                style={{ padding: "10px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px", background: "#fff" }}
                            >
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                    <div style={{ display: "flex", gap: "12px", marginTop: "10px" }}>
                        <button
                            type="submit"
                            disabled={saving}
                            style={{
                                padding: "12px 24px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: "10px",
                                fontWeight: "600", cursor: "pointer", flex: 1
                            }}
                        >
                            {saving ? "Saving..." : "Save Changes"}
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate("/dashboard/properties")}
                            style={{
                                padding: "12px 24px", background: "#f8fafc", color: "#64748b", border: "1px solid #e2e8f0",
                                borderRadius: "10px", fontWeight: "500", cursor: "pointer"
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EditProperty;
